import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Long-time client",
    rating: 5,
    text: "This guy is the best. Great online coach. With my crazy schedule he has helped me reach my goals. Highly recommend!",
    tag: "Online Coaching",
  },
  {
    name: "1-on-1 Client",
    rating: 5,
    text: "I have worked with Meño for a year. He is the best guy to go to. He will show you the exercises, he'll work out with you! He also does amazing one-to-one sessions.",
    tag: "Personal Training",
  },
  {
    name: "Sai's Parent",
    rating: 5,
    text: "Coach Manny at Meño Coaching – Pushing Limits has been great to work with. Since my son Sai started training with him, I've seen a big improvement in his confidence.",
    tag: "Youth Development",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
              / 03 — Real results
            </div>
            <h2
              data-testid="testimonials-title"
              className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-[0.9]"
            >
              What clients
              <br />
              are saying.
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  size={18}
                  fill="#FF3B30"
                  strokeWidth={0}
                  className="text-[#FF3B30]"
                />
              ))}
            </div>
            <div className="text-white/70 text-sm">
              <span className="font-display text-2xl text-white mr-2">5.0</span>
              from 16 Google reviews
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className="relative bg-[#171717] border border-white/10 p-8 hover:border-[#FF3B30]/50 transition-colors"
            >
              <Quote
                size={40}
                className="text-[#FF3B30] opacity-60 mb-6"
                strokeWidth={1.2}
              />
              <p className="text-white/85 text-base md:text-lg leading-relaxed">
                “{r.text}”
              </p>
              <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                <div>
                  <div className="font-display text-lg uppercase tracking-wider">
                    {r.name}
                  </div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-1">
                    {r.tag}
                  </div>
                </div>
                <div className="flex">
                  {Array.from({ length: r.rating }).map((_, j) => (
                    <Star
                      key={j}
                      size={12}
                      fill="#FF3B30"
                      strokeWidth={0}
                      className="text-[#FF3B30]"
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
